"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
/* eslint-disable */
/* tslint:disable */
var React = tslib_1.__importStar(require("react"));
var ArrowDownIcon = function (_a) {
    var size = _a.size, props = tslib_1.__rest(_a, ["size"]);
    return (React.createElement("svg", tslib_1.__assign({ viewBox: "0 0 10 6", fill: "currentColor", width: size || '1em', height: size || '1em' }, props),
        React.createElement("path", { fill: "currentColor", id: "a", d: "M4.9,4.2L0.8,0.1L0.1,0.8l4.1,4.1L4.1,5.1l0.7,0.7l0.1-0.1l0.1,0.1l0.7-0.7L5.7,4.9l4.1-4.1L9.1,0.1L4.9,4.2z" })));
};
ArrowDownIcon.displayName = 'ArrowDownIcon';
exports.default = ArrowDownIcon;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=ArrowDownIcon.js.map